// import { cloneDeep, isEqual } from 'lodash'

export type IndexT = string | number | symbol
export type ObjectT = Record<IndexT, unknown>

export function _merge<T> (obj1: T, obj2: T): T {
  if (obj1 instanceof Array || Array.isArray(obj1) ||
      obj2 instanceof Array || Array.isArray(obj2)) {
    const obj1_ = (obj1 ?? []) as unknown[]
    const obj2_ = (obj2 ?? []) as unknown[]
    return [...obj1_, ...obj2_.filter((i) => !obj1_.includes(i))] as unknown as T
  }
  if (obj1 == null || obj2 == null) {
    return obj1 ?? obj2
  }
  const result = { ...obj1 }
  for (const key in obj2) {
    const value = obj2[key]
    if (value == null) {
      continue
    }
    if (typeof value === 'object') {
      result[key] = _merge(result[key], value)
    } else {
      result[key] = value
    }
  }
  return result
}

export function deepEqual (a: unknown, b: unknown): boolean {
  // return isEqual(a, b)
  if (isObject(a) && isObject(b)) {
    const aObj = a as ObjectT
    const bObj = b as ObjectT
    const aKeys = Object.keys(aObj)
    const bKeys = Object.keys(bObj)

    if (aKeys.length !== bKeys.length) {
      return false
    }

    for (const key of aKeys) {
      const aVal = aObj[key]
      const bVal = bObj[key]

      if (Array.isArray(aVal)) {
        if (!Array.isArray(bVal)) {
          return false
        }
        if (aVal.length !== bVal.length) {
          return false
        }
        if (!aVal.every((a) => bVal.some((b) => deepEqual(a, b)))) {
          return false
        }
      } else {
        const isObjects = isObject(aVal) && isObject(bVal)

        if ((isObjects && !deepEqual(aVal, bVal)) || (!isObjects && aVal !== bVal)) {
          return false
        }
      }
    }
    return true
  } else {
    return a === b
  }
}

export function isObject (object: unknown): boolean {
  return object !== null && typeof object === 'object'
}

// eslint-disable-next-line
export function deepCopy (src: unknown): any {
  // return cloneDeep(src)
  return JSON.parse(safeStringify(src))
}

function safeStringify (obj: unknown) {
  const seen = new WeakSet()
  return JSON.stringify(obj, (k, v) => {
    if (v !== null && typeof v === 'object') {
      if (seen.has(v)) { return }
      seen.add(v)
    }
    return v
  })
}